import {
  CenterCulturalOuting,
  CenterCulturalOutingInput
} from '../../../lib/types/models/center/center-cultural-outing'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function updateCenterCulturalOutings(id: number, data: CenterCulturalOutingInput[]) {
  return restApiClient
    .url(constructApiUrl(API.centers.updateCenterCulturalOutings.url, { id }))
    .patch<CenterCulturalOuting[], CenterCulturalOutingInput[]>(data)
}

export function updateCenterCulturalOuting(
  centerId: number,
  centerCulturalOutingId: number,
  data: CenterCulturalOutingInput
) {
  return restApiClient
    .url(
      constructApiUrl(API.centers.updateCenterCulturalOuting.url, {
        id: centerId,
        centerCulturalOutingId
      })
    )
    .patch<CenterCulturalOuting, CenterCulturalOutingInput>(data)
}
